import React, { useState, useEffect, useMemo, useRef } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import redirectURL from "../redirectURL";
import { FaInfoCircle } from "react-icons/fa";
import { MdOutlineFileUpload } from "react-icons/md";
import { utils, writeFile } from "xlsx";
import * as XLSX from "xlsx";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./datepicker.css"

const OpenPO = () => {
    const [loadshow, setLoadshow] = useState("show-n");
    const [overlayBlock, setOverlayBlock] = useState("show-n");
    const [overlyBlock, setOverlyBlock] = useState("show-n");
    const [show, setShow] = useState(false);
    const [basicTitle, setBasicTitle] = useState("");
    const [basicType, setBasicType] = useState("default");
    const [rowData, setRowData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [showTooltip, setShowTooltip] = useState(false);
    const [isSliderOpen, setSliderOpen] = useState(false);
    const [sliderTitle, setSliderTitle] = useState("");
    const [uploadedFileData, setUploadedFileData] = useState([]);
    const [file, setFile] = useState(null);
    const [highlightedDates, setHighlightedDates] = useState([]);


    const [destination, setDestination] = useState({ label: "ALL", value: "" });
    const [selectedDate, setSelectedDate] = useState("");
    const [destinationOptions, setDestinationOptions] = useState([{ label: "ALL", value: "" }]);

    const gridApi = useRef(null);
    const gridColumnApi = useRef(null);

    // Date helper functions
    const pad2 = (n) => String(n).padStart(2, "0");
    const formatDateForInput = (date) => {
        if (!date) return '';
        const d = new Date(date);
        return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
    };
    
    const todayYMD = () => {
        const d = new Date();
        return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
    };

    const columnWithDefs = [
        {
            headerName: "Sku Code",
            field: "sku_code",
            tooltipField: "sku_code",
            sortable: true,
            resizable: true,
            width: 120,
        },
        {
            headerName: "Sku Name",
            field: "sku_name",
            tooltipField: "Sku Name",
            sortable: true,
            resizable: true,
            width: 120,
        },
        {
            headerName: "SKU Category",
            field: "sku_category",
            tooltipField: "Sku Category",
            sortable: true,
            resizable: true,
            width: 120,
        },
        {
            headerName: "Destination Store ID",
            field: "destination_store_id",
            tooltipField: "Destination Store ID",
            sortable: true,
            resizable: true,
            width: 120,
        },
        {
            headerName: "Destination Store Name",
            field: "destination_store_name",
            tooltipField: "destination_store_name",
            sortable: true,
            resizable: true,
            width: 150,
        },
        {
            headerName: "Channel",
            field: "channel",
            tooltipField: "channel",
            sortable: true,
            resizable: true,
            width: 100,
            valueFormatter: (params) => {
                if (params.value !== null && params.value !== undefined) {
                    return params.value.toLocaleString();
                }
                return '0';
            }
        },
        {
            headerName: "Unicom ID",
            field: "unicom_id",
            tooltipField: "unicom_id",
            sortable: true,
            resizable: true,
            width: 150,
        },
        {
            headerName: "Quantity",
            field: "quantity",
            tooltipField: "quantity",
            sortable: true,
            resizable: true,
            width: 150,
            valueFormatter: (params) => {
                if (params.value !== null && params.value !== undefined) {
                    return params.value.toLocaleString();
                }
                return '0';
            }
        },
        {
            headerName: "Open Po Stock",
            field: "open_po_stock",
            tooltipField: "open_po_stock",
            sortable: true,
            resizable: true,
            width: 180,
        },
    ];

    const sideBar = useMemo(() => ({
        toolPanels: [
            {
                id: "columns",
                labelDefault: "Columns",
                labelKey: "columns",
                iconKey: "columns",
                toolPanel: "agColumnsToolPanel",
            },
            {
                id: "filters",
                labelDefault: "Filters",
                labelKey: "filters",
                iconKey: "filter",
                toolPanel: "agFiltersToolPanel",
            },
        ]
    }), []);

    const statusPanel = {
        statusPanels: [
            {
                statusPanel: "agTotalAndFilteredRowCountComponent",
                align: "left"
            },
            {
                statusPanel: "agTotalRowCountComponent",
                align: "center"
            },
            { statusPanel: "agFilteredRowCountComponent" },
            { statusPanel: "agSelectedRowCountComponent" },
            { statusPanel: "agAggregationComponent" }
        ]
    };

    const defaultColDef = {
        sortable: true,
        filter: true,
        resizable: true,
        minWidth: 150,
    };
          const getHighlightedDates = async () => {  
      try {
        const response = await redirectURL.post("indentation/getOpenpodates", {});
        if (response.status === 200 && response.data.dates) {
          const dates = response.data.dates.map(dateStr => {
            try {
              return new Date(dateStr);
            } catch (e) {
              return null;
            }
          }).filter(date => date !== null);
          setHighlightedDates(dates);
        }
      } catch (error) {
        console.error("Failed to fetch highlighted dates:", error);
      }
    }

    const onGridReady = (params) => {
        gridApi.current = params.api;
        gridColumnApi.current = params.columnApi;

        setTimeout(() => {
            if (gridApi.current) {
                gridApi.current.sizeColumnsToFit();
            }
        }, 100);
    };

    const onFirstDataRendered = (params) => {
        setTimeout(() => {
            if (gridApi.current) {
                gridApi.current.sizeColumnsToFit();
            }
        }, 100);
    };

    const getOpenPOData = async (dateStr = null, destValue = null) => {
        try {
            setLoadshow("show-m");
            setOverlayBlock("show-m");
            
            const payload = { date: dateStr };
            const response = await redirectURL.post("indentation/getOpenPOData", payload);

            if (response.status === 200) {
                if (response.data.status === "success" && response.data.data && response.data.data.length > 0) {
                    const data = response.data.data;
                    setRowData(data);
                    
                    // Apply destination filter only if provided (when Apply is clicked)
                    let filtered = data;
                    if (destValue) {
                        filtered = filtered.filter(
                            (item) => item.destination_store_id === destValue
                        );
                    }
                    setFilteredData(filtered);

                    // Update the selected date with the actual filtered date from backend
                    if (response.data.filteredDate) {
                        setSelectedDate(formatDateForInput(response.data.filteredDate));
                    }
                    await getHighlightedDates();
                    getDestinationOptions(data);
                } else {
                    setBasicTitle(response.data.message || "No open PO data found");
                    setBasicType("info");
                    setShow(true);
                    setRowData([]);
                    setFilteredData([]);
                }
            }
        } catch (error) {
            console.error("Error fetching open PO data:", error);
            setBasicTitle("Failed to fetch open PO data");
            setBasicType("error");
            setShow(true);
        } finally {
            setLoadshow("show-n");
            setOverlayBlock("show-n");
        }
    };

    const getDestinationOptions = (data) => {
        try {
            const destinationsMap = new Map();
            data.forEach(item => {
                if (item.destination_store_id && item.destination_store_name) {
                    const key = `${item.destination_store_id}-${item.destination_store_name}`;
                    if (!destinationsMap.has(key)) {
                        destinationsMap.set(key, {
                            destination_store_id: item.destination_store_id,
                            destination_store_name: item.destination_store_name
                        });
                    }
                }
            });

            const destinations = Array.from(destinationsMap.values());
            const options = [
                { label: "ALL", value: "" },
                ...destinations.map(dest => ({
                    value: dest.destination_store_id,
                    label: `${dest.destination_store_id} - ${dest.destination_store_name}`
                }))
            ];

            setDestinationOptions(options);
        } catch (error) {
            console.error("Error processing destination options:", error);
            setDestinationOptions([{ label: "ALL", value: "" }]);
        }
    };

    const applyAllFilters = async () => {
        try {
            setLoadshow("show-m");
            setOverlayBlock("show-m");

            // Fetch data with selected date AND destination filter (server-side + client-side)
            await getOpenPOData(selectedDate, destination.value);
            
        } catch (error) {
            console.error("Error applying filters:", error);
            setBasicTitle("Failed to apply filters");
            setBasicType("error");
            setShow(true);
        } finally {
            setTimeout(() => {
                setLoadshow("show-n");
                setOverlayBlock("show-n");
            }, 400);
        }
    };

    const resetAllFilters = async () => {
        try {
            setLoadshow("show-m");
            setOverlayBlock("show-m");

            // Reset destination filter
            setDestination({ label: "ALL", value: "" });
            
            // Fetch latest date data (empty date will trigger latest date in backend)
            await getOpenPOData();
            
        } catch (error) {
            console.error("Error resetting filters:", error);
        } finally {
            setTimeout(() => {
                setLoadshow("show-n");
                setOverlayBlock("show-n");
            }, 400);
        }
    };

    const fetchData = async () => {
        setLoadshow("show-m");
        setOverlayBlock("show-m");
        // Fetch latest date data by default
        await getOpenPOData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
    };

    // Reset destination to ALL when date changes
    const handleDateChange = (newDate) => {
        setSelectedDate(newDate);
        setDestination({ label: "ALL", value: "" });
    };

    // Download Excel Template
    const downloadExcelTemplate = () => {
        const sampleData = [
            ["main_channel", "Channel", "sku_old", "City", "Unicom ID", "qty", "Product Code*", "Component Quantity", "component Product Code", "Total Qty", "Unicom Code", "SKU Code"],
            ["Qcom", "Instamart", "MCFC", "Gurgaon", "F142340293", "99", "", "12", "F1234", "34", "F1234", "BDM"]
        ];

        const ws = utils.aoa_to_sheet(sampleData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "OpenPOTemplate");
        writeFile(wb, "open_po_template.xlsx");
    };

    // Handle File Change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setFile(e.target.value);
        
        if (!file) return;
        
        const reader = new FileReader();
        reader.onload = (event) => {
            try {
                const data = new Uint8Array(event.target.result);
                const workbook = XLSX.read(data, { type: "array" });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                
                const parsedData = XLSX.utils.sheet_to_json(worksheet, {
                    raw: false,
                    dateNF: "yyyy-mm-dd",
                });

                console.log("Parsed Excel data:", parsedData);

                // No validation - accept all data as is
                const result = parsedData.map(item => {
                    const newItem = {};
                    // Copy all fields as they are from Excel
                    for (const key in item) {
                        if (item[key] !== undefined && item[key] !== null) {
                            newItem[key] = item[key];
                        }
                    }
                    return newItem;
                });

                console.log("Processed data for upload:", result);
                setUploadedFileData(result);
                
            } catch (error) {
                console.error("Error processing file:", error);
                setShow(true);
                setBasicType("error");
                setBasicTitle("Error processing file. Please check the file format.");
            }
        };
        reader.onerror = () => {
            setShow(true);
            setBasicType("error");
            setBasicTitle("Error reading file");
        };
        reader.readAsArrayBuffer(file);
    };

   const onClickingFileSubmit = async () => {
    if (uploadedFileData.length === 0) {
        setShow(true);
        setBasicType("info");
        setBasicTitle("Please upload a valid file");
        return;
    }

    try {
        setLoadshow("show-m");
        setOverlayBlock("show-m");

        const params = { 
            data: uploadedFileData 
        };

        const response = await redirectURL.post(
            "indentation/UploadOpenPOData",
            params
        );

        // ✅ NEW SUCCESS CHECK (HTTP 200 + success message or status)
        const isSuccess =
            response.status === 200 &&
            (
                response.data.status?.toLowerCase() === "success" ||
                response.data.message?.toLowerCase().includes("success")
            );

        if (isSuccess) {
            const successMessage = response.data.message || "Open PO data uploaded successfully";

            console.log("Success message:", successMessage);

            setUploadedFileData([]);
            await getOpenPOData();

            setShow(true);
            setBasicType("success");
            setBasicTitle(successMessage);

            hideOverlySlideBlock();

            // Trigger success user action
            const userData = {
                email: localStorage.getItem("email"),
                user_code: localStorage.getItem("user_code"),
                action: "Bulk Uploaded Open PO Data",
                status: "Success",
                path: window.location.pathname
            };
            triggerUserAction(userData);

        } else {
            // ❌ FAILURE CASE
            const errorMessage = response.data.message || "Data upload failed";

            console.log("Error message:", errorMessage);

            setShow(true);
            setBasicType("error");
            setBasicTitle(errorMessage);

            const userData = {
                email: localStorage.getItem("email"),
                user_code: localStorage.getItem("user_code"),
                action: "Bulk Uploaded Open PO Data",
                status: "Failure",
                path: window.location.pathname
            };
            triggerUserAction(userData);
        }

    } catch (error) {
        console.error("Upload error:", error);

        const errorMessage =
            error.response?.data?.message ||
            "An error occurred while uploading data";

        setUploadedFileData([]);
        setShow(true);
        setBasicType("error");
        setBasicTitle(errorMessage);

        // Trigger failure user action
        const userData = {
            email: localStorage.getItem("email"),
            user_code: localStorage.getItem("user_code"),
            action: "Bulk Uploaded Open PO Data",
            status: "Failure",
            path: window.location.pathname
        };
        triggerUserAction(userData);

    } finally {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
    }
};


    // Upload Button Click
    const onClickUploadOpenPOData = () => {
        setUploadedFileData([]);
        setSliderOpen(true);
        setSliderTitle("Upload Open PO Data");
        setOverlyBlock("show-m");
    };

    // Hide Slider
    const hideOverlySlideBlock = () => {
        setOverlyBlock("show-n");
        setSliderOpen(false);
        if (document.getElementById("bulkUploadFile")) {
            document.getElementById("bulkUploadFile").value = "";
        }
        setUploadedFileData([]);
        setFile(null);
    };

    // Close Slider Icon
    const onClickingSliderCloseIcon = () => {
        setOverlyBlock("show-n");
        setSliderOpen(false);
        if (document.getElementById("bulkUploadFile")) {
            document.getElementById("bulkUploadFile").value = "";
        }
        setUploadedFileData([]);
        setFile(null);
    };

    // User Action Triggering
    const triggerUserAction = (trigerdata) => {
        redirectURL.post('inventory/triggerUserAction', trigerdata)
    };

    useEffect(() => {
        // Fetch latest date data on component mount
        fetchData();
    }, []);

    const closeAlert = () => {
        setShow(false);
        setBasicType("default");
        setBasicTitle("");
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setOverlyBlock("show-n");
        setSliderOpen(false)
        setUploadedFileData([])
        setFile(null)
        if (document.getElementById("bulkUploadFile")) {
            document.getElementById("bulkUploadFile").value = "";
        }
    };

    return (
        <>
            <div className="container-fluid mt-3">
                <div style={{ zIndex: "9999999" }}>
                    <SweetAlert
                        show={show}
                        type={basicType}
                        title={basicTitle}
                        onConfirm={closeAlert}
                        style={{ fontSize: "9px" }}
                    >
                    </SweetAlert>
                </div>

                <div className="row" style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}>
                    <form className="col-sm-12 p-0 mt-4 mb-4" style={{ display: "flex", alignItems: "center" }}>
                        <div className="col-sm-10 row" style={{ display: "flex", alignItems: "end" }}>
                            {/* Date Filter */}
                            <div className="col-sm-2 mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label htmlFor="selectedDate" style={{ fontSize: '13px', fontWeight: '400', marginBottom: '5px' }}>
                                    Date:
                                </label>
                                <DatePicker
                                    selected={selectedDate ? new Date(selectedDate) : null}
                                    onChange={(date) => handleDateChange(date ? formatDateForInput(date) : '')}
                                    dateFormat="yyyy-MM-dd"
                                    className="form-control"
                                    placeholderText="Select Date"
                                    maxDate={new Date()}
                                    highlightDates={highlightedDates}
                                    style={{
                                        padding: '8px',
                                        borderRadius: '5px',
                                        border: '1px solid #d9d9d9',
                                        fontSize: '12px',
                                        minHeight: '38px',
                                        cursor: 'pointer'
                                    }}
                                />
                            </div>

                            {/* Destination Store Filter */}
                            <div className="col-sm-2 mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label htmlFor="destination" style={{ fontSize: '13px', fontWeight: '400', marginBottom: '5px' }}>
                                    Destination Store ID:
                                </label>
                                <Select
                                    id="destination"
                                    value={destination}
                                    onChange={(selectedOption) => setDestination(selectedOption)}
                                    options={destinationOptions}
                                    styles={selectStyles}
                                />
                            </div>

                            {/* Apply & Reset Buttons */}
                            <div className="col-sm-3 mb-1" style={{ display: "flex", alignItems: "center", gap: "10px", marginLeft: '10px' }}>
                                <button
                                    type="button"
                                    onClick={(e) => { e.preventDefault(); applyAllFilters(); }}
                                    style={{
                                        backgroundColor: "#93385D",
                                        color: "#fff",
                                        borderRadius: "5px",
                                        padding: "8px 20px",
                                        border: "none",
                                        cursor: "pointer",
                                        minHeight: '38px'
                                    }}
                                >
                                    Apply
                                </button>
                                <button
                                    onClick={(e) => { e.preventDefault(); resetAllFilters(); }}
                                    type="button"
                                    style={{
                                        backgroundColor: "#fff",
                                        color: "#000",
                                        borderRadius: "5px",
                                        padding: "8px 20px",
                                        border: "1px solid #d9d9d9",
                                        cursor: "pointer",
                                        minHeight: '38px'
                                    }}
                                >
                                    Reset
                                </button>
                            </div>
                        </div>

                        {/* Upload Button */}
                        <div className="col-sm-2 d-flex justify-content-end">
                            <button
                                type="button"
                                onClick={onClickUploadOpenPOData}
                                className="mr-2"
                                style={{
                                    ...addButtonStyle,
                                    backgroundColor: "#F4EBEF",
                                    color: "#93385D",
                                    border: "2px solid #93385D",
                                }}
                            >
                                <MdOutlineFileUpload style={{ color: "#93385D", fontSize: "20px" }} />
                                &nbsp;
                                Upload Open PO
                            </button>
                        </div>
                    </form>

                    {/* Data Grid */}
                    <div className="col-sm-12 p-0 pl-2 mt-6">
                        <div
                            className="ag-theme-alpine"
                            style={{
                                height: 'calc(100vh - 250px)',
                                width: "100%",
                                minHeight: '400px'
                            }}
                        >
                            <AgGridReact
                                rowData={filteredData}
                                columnDefs={columnWithDefs}
                                defaultColDef={defaultColDef}
                                domLayout="normal"
                                onGridReady={onGridReady}
                                onFirstDataRendered={onFirstDataRendered}
                                sideBar={sideBar}
                                statusBar={statusPanel}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Upload Slider */}
            <div
                className={`stock-status-slider ${isSliderOpen ? "open" : ""} slider-25`}
                style={{ width: "25%" }}
            >
                <div className="slider-header-container d-flex justify-content-between">
                    <p className="m-0p">{sliderTitle}</p>
                    <p
                        className="m-0p"
                        style={{ cursor: "pointer" }}
                        onClick={onClickingSliderCloseIcon}
                    >
                        X&nbsp;&nbsp;&nbsp;
                    </p>
                </div>
                
                <div style={{ display: "flex", flexDirection: "column", height: "100%", overflowY: "auto", padding: 5 }}>
                    <div style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }}>
                        <div className="d-flex justify-content-end mb-10p">
                            <button
                                id="sample-download-button"
                                onClick={downloadExcelTemplate}
                                style={{
                                    padding: "8px 16px",
                                    backgroundColor: "#93385D",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                    fontSize: "0.8rem"
                                }}
                            >
                                {"Download Sample Template"}
                            </button>
                        </div>
                        <input
                            type="file"
                            accept=".csv,.xlsx,.xls"
                            onChange={handleFileChange}
                            style={{
                                border: "1px solid lightgrey",
                                width: "100%",
                                padding: "8px",
                                borderRadius: "5px",
                                backgroundColor: "#f9f9f9",
                                color: "#000",
                                fontSize: "13px",
                            }}
                            value={file}
                            id="bulkUploadFile"
                        />
                        <p style={{ color: "red", fontSize: "13px", margin: "0px", marginTop: "10px" }}>
                            *Accept .csv & .xlsx files only
                        </p>
                        <div style={{ textAlign: "right", marginTop: "10px" }}>
                            <button
                                style={{ 
                                    backgroundColor: uploadedFileData.length > 0 ? "#93385D" : "#ccc", 
                                    color: "#fff", 
                                    fontSize: "0.8rem",
                                    padding: "8px 20px",
                                    border: "none",
                                    borderRadius: "5px",
                                    cursor: uploadedFileData.length > 0 ? "pointer" : "not-allowed"
                                }}
                                onClick={(e) => {
                                    if (uploadedFileData.length > 0) {
                                        setLoadshow("show-m");
                                        setOverlayBlock("show-m");
                                        onClickingFileSubmit(e);
                                    }
                                }}
                                disabled={uploadedFileData.length === 0}
                            >
                                {"Submit"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
            <div className={`overlay-block ${overlayBlock}`}></div>
            <div
                className={"overly-block " + overlyBlock}
                onClick={hideOverlySlideBlock}
            ></div>
        </>
    );
};

const selectStyles = {
    control: (base) => ({
        ...base,
        padding: '1px',
        borderRadius: '5px',
        border: '1px solid #d9d9d9',
        minHeight: '38px'
    }),
    singleValue: (base) => ({
        ...base,
        fontWeight: 'normal',
        color: '#333',
        fontSize: "12px"
    }),
    option: (base, state) => ({
        ...base,
        fontSize: "13px",
        fontWeight: state.isSelected ? 'normal' : 'normal',
    })
};

const addButtonStyle = {
    padding: "8px 20px",
    backgroundColor: "#93385D",
    color: "#fff",
    fontFamily: "sans-serif",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "0.8rem",
    fontWeight: "bold",
};

export default OpenPO;